/*=========================================================================================
  File Name: authStorage.js
  Description: 
  ----------------------------------------------------------------------------------------
  Item Name: Auth Local Storage
  Author: Tan Tran
==========================================================================================*/
function storeAuth(auth) {
    localStorage.setItem('auth', JSON.stringify(auth));
  }
  
  function getAuth() {
    var auth = JSON.parse(localStorage.getItem('auth'));
    return auth;
  }
  
    
  function clearAuth() {
    localStorage.removeItem('auth');
  }
  
  export default {
    name: 'authStorage',
    storeAuth,
    getAuth,
    clearAuth
   
  } 